import { render } from "./StatPue.vue?vue&type=template&id=4fa029f9"
import script from "./StatPue.vue?vue&type=script&lang=js"
export * from "./StatPue.vue?vue&type=script&lang=js"

import "./StatPue.vue?vue&type=style&index=0&id=4fa029f9&lang=css"

import exportComponent from "C:\\Program Files\\Jenkins\\.jenkins\\workspace\\Статистика приема\\Univeris.AdmissionStatistics.Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__